import { render, staticRenderFns } from "./CTableColumn.vue?vue&type=template&id=c111964e&"
import script from "./CTableColumn.vue?vue&type=script&lang=js&"
export * from "./CTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports